document.addEventListener('DOMContentLoaded', () => {
  new Swiper('.p-about__gallery', {
    slidesPerView: 'auto',
    centeredSlides: true,
    spaceBetween: 20,
    loop: true,
    speed: 18000,
    allowTouchMove: false,
    autoplay: { delay: 0, disableOnInteraction: false },
  });

  const strengthContainers = Array.from(document.querySelectorAll('.p-about__strength-points'));
  const mq = window.matchMedia('(max-width: 767px)');
  let strengthSwipers = [];

  function initStrengthSwipers() {
    if (strengthSwipers.length > 0) return;

    strengthSwipers = strengthContainers.map((container) => {
      const wrap = container.closest('.c-swiper__wrap');
      const paginationEl = wrap?.querySelector('.swiper-pagination');
      const nextEl = wrap?.querySelector('.swiper-button-next');
      const prevEl = wrap?.querySelector('.swiper-button-prev');

      return new Swiper(container, {
        slidesPerView: 1,
        loop: true,
        pagination: paginationEl
          ? {
              el: paginationEl,
              clickable: true,
            }
          : undefined,
        navigation:
          nextEl && prevEl
            ? {
                nextEl,
                prevEl,
              }
            : undefined,
      });
    });
  }

  function destroyStrengthSwipers() {
    strengthSwipers.forEach((instance) => instance.destroy(true, true));
    strengthSwipers = [];
  }

  function switchSwiper(e) {
    if (e.matches) {
      // SP: Swiper 起動
      initStrengthSwipers();
    } else {
      // PC: Swiper 破棄（インラインスタイルもクリーンアップ）
      if (strengthSwipers.length) {
        destroyStrengthSwipers();
      }
    }
  }

  mq.addEventListener('change', switchSwiper);
  switchSwiper(mq);
});
